import axios from 'axios';

// const baseUrlIdentificacionDigital = 'https://identificaciondigital.qa.api.hircasa.com/Incode'; 
// QA - LINK
const baseUrlIdentificacionDigital = process.env.VUE_APP_URL_IDENTIFICACION_DIGITAL; 
const baseUrlFirmaSimple = process.env.VUE_APP_URL_FIRMASIMPLE_API; 


const embajadoresApi = axios.create({
  headers: {
    'Content-type': 'application/json',
  },
});

/* Prospecto */
export const obtenerProspectoRepresentanteLegal = async (prospectoId) => {
    const { data } = await embajadoresApi.get(`/api/Master/Prospecto/ObtenerProspectoRepresentanteLegal?prospectoId=${prospectoId}`);  
    return data.data;
}

export const obtenerDatosProspectoBuroCredito = async (prospectoId) => {
  const { data } = await embajadoresApi.get(`/api/Master/Prospecto/ObtenerDatosProspectoBuro?prospectoId=${prospectoId}`);
  return data.data;
}

export const enviarDatosProspectoBuroCredito = async (datosPersonales) => {
  await embajadoresApi.post(`${baseUrlFirmaSimple}/api/Master/FirmaSimple/GuardarConsultaAutorizacionBuroCredito`, (datosPersonales));
}

export const ObtenerAutorizacionBuroApi = async (prospectoId) => {
  const { data }  = await embajadoresApi.get(`/api/Master/PreAutorizacion/VerificarAutorizacion?prospectoId=${prospectoId}`);
  return data;
}
/* Integración de expediente */
export const ProspectoTieneArchivoBuroCredito = async (prospectoId) => {
  const { data }  = await embajadoresApi.get(`/api/Master/IntegracionExpediente/TieneArchivoBuroCredito?prospectoId=${prospectoId}`);
  return data;
}

/* Sesiones Incode */
export const getSession = async (prospectoId ) => {
  const { data } =  await embajadoresApi.get(`${baseUrlIdentificacionDigital}/SesionIncode/${prospectoId}`);
  return data == '' ? null : data;
}
export const saveSession = async (session) => {
  await embajadoresApi.post(`${baseUrlIdentificacionDigital}/SesionIncode`, session);
}
export const updateSession =  async (prospectoId) => {
  await embajadoresApi.put(`${baseUrlIdentificacionDigital}/SesionIncode/${prospectoId}`);
}